
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M15 30c8.28 0 15-6.72 15-15 0-8.28-6.72-15-15-15C6.72 0 0 6.72 0 15c0 8.28 6.72 15 15 15zm4.41-23.1l3.69 3.69-2.31 2.31-3.69-3.69 2.31-2.31zM8.34 17.97l7.86-7.86 3.69 3.69-7.86 7.86-4.62.93.93-4.62z","fill":"#000","fill-rule":"nonzero","opacity":".25"}})])
      }
    
      }
    